/**
 * 常用快捷键拦截（黑名单）：不拦截普通打字、方向键、Tab、Delete 等输入相关按键。
 * 仅阻止开发者工具、整页缩放、刷新、新标签页、打印、查看源码等常见入口（无法彻底防作弊）。
 */
import { isFullscreen } from "./fullscreen.js";

/**
 * @param {{ getActive: () => boolean }} ctx
 * @returns {{ attach: () => void; detach: () => void }}
 */
export function createKeyboardGuard(ctx) {
  const handleKeyDown = (e) => {
    if (!ctx.getActive()) return;

    // 全屏下拦截 ESC，避免浏览器默认「退出全屏」（部分环境仍可能由系统接管，无法 100% 屏蔽）
    if (e.key === "Escape" && isFullscreen()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const mod = e.ctrlKey || e.metaKey;

    // 浏览器整页缩放
    if (mod && ["+", "-", "=", "0", "_"].includes(e.key)) {
      e.preventDefault();
      return;
    }

    if (e.key === "F11" || e.key === "F12") {
      e.preventDefault();
      return;
    }

    // 刷新
    if (e.key === "F5" || (mod && (e.key === "r" || e.key === "R"))) {
      e.preventDefault();
      return;
    }

    // 新标签页 / 新窗口
    if (mod && ["n", "N", "t", "T", "w", "W"].includes(e.key)) {
      e.preventDefault();
      return;
    }

    // 打印 / 另存为 / 查看源码 / 打开文件
    if (mod && ["p", "P", "s", "S", "u", "U", "o", "O"].includes(e.key)) {
      e.preventDefault();
      return;
    }

    // Chrome 聚焦地址栏
    if (mod && ["l", "L", "k", "K"].includes(e.key)) {
      e.preventDefault();
      return;
    }

    // 开发者工具常见快捷键（Win）
    if (e.ctrlKey && e.shiftKey && ["I", "J", "C", "K"].includes(e.key.toUpperCase())) {
      e.preventDefault();
      return;
    }

    // 开发者工具（macOS）
    if (e.metaKey && e.altKey && ["I", "J", "C"].includes(e.key.toUpperCase())) {
      e.preventDefault();
      return;
    }
  };

  return {
    attach() {
      window.addEventListener("keydown", handleKeyDown, true);
    },
    detach() {
      window.removeEventListener("keydown", handleKeyDown, true);
    },
  };
}
